// Lightweight number tween for stepper feedback.

export function tweenNumber(
  input: HTMLInputElement,
  to: number,
  durationMs = 180,
): void {
  const from = Number.parseFloat(input.value || '0');
  if (!Number.isFinite(from) || from === to) {
    input.value = String(to);
    return;
  }
  const start = performance.now();
  const decimals = decimalPlaces(to);
  function step(now: number) {
    const t = Math.min(1, (now - start) / durationMs);
    const eased = 1 - (1 - t) * (1 - t); // easeOutQuad
    const v = from + (to - from) * eased;
    input.value = decimals > 0 ? v.toFixed(decimals) : String(Math.round(v));
    if (t < 1) requestAnimationFrame(step);
    else input.value = String(to);
  }
  requestAnimationFrame(step);
}

function decimalPlaces(n: number): number {
  if (Number.isInteger(n)) return 0;
  const s = String(n);
  const i = s.indexOf('.');
  return i === -1 ? 0 : Math.min(s.length - i - 1, 2);
}
